const metrics = [
  { label: 'Revenue Visibility', value: 'Improved', icon: 'ri-funds-line' },
  { label: 'Operational Bottlenecks', value: 'Reduced', icon: 'ri-speed-line' },
  { label: 'Compliance Confidence', value: 'Increased', icon: 'ri-verified-badge-line' },
  { label: 'Lead-to-Conversion', value: 'Elevated', icon: 'ri-arrow-up-circle-line' },
];

export default function PerformanceSection() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1a70ef050c1f708913ff64b03834d5bd.jpg"
          alt="Performance metrics background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0B1F3A] bg-opacity-90"></div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-8 lg:px-20">
        <h2 className="text-[44px] font-semibold text-white text-center mb-20 leading-tight">
          Measured outcomes. Not marketing noise.
        </h2>

        <div className="grid grid-cols-4 gap-6 mb-16">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="bg-white/5 border border-white/10 rounded-xl p-8 text-center hover:bg-white/8 transition-colors"
            >
              <div className="w-12 h-12 rounded-full bg-[#1EB6B0]/15 flex items-center justify-center mx-auto mb-5">
                <i className={`${metric.icon} text-xl text-[#1EB6B0]`}></i>
              </div>
              <p className="text-sm text-white/45 uppercase tracking-wider mb-3">
                {metric.label}
              </p>
              <p className="text-[40px] font-bold text-[#1EB6B0]">{metric.value}</p>
            </div>
          ))}
        </div>

        <p className="text-base text-white/50 text-center max-w-[640px] mx-auto">
          Our work is designed to produce quantifiable performance gains across revenue,
          operations, and compliance.
        </p>
      </div>
    </section>
  );
}
